import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Lazy-load route bundles to reduce initial JS without changing UI
const Home = lazy(() => import('./pages/Home'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const ThankYou = lazy(() => import('./pages/ThankYoupage')); // Add this route

function App() {
  return (
    // keep your basename if you need it for deployment
    <Router>
      <ScrollToTop />
      <Navbar />
      <div style={{ minHeight: '100vh' }}>
        <Suspense
          fallback={
            <div className="visually-hidden" aria-live="polite">
              Loading…
            </div>
          }
        >
          <Routes>
            {/* single canonical home route */}
           
            <Route path="/" element={<Home />} />

            {/* other pages */}
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/thank-you" element={<ThankYou />} /> {/* Add this route */}
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </Router>
  );
}

export default App;